import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createPrizeItemBody } from '../../../services/api/apiPayloads';
import {
    getPrizeList,
    openPrizeEditor,
    renderPrizeEditor,
    updatePrize,
} from '../../../store/actions/prizeActions';
import Prize from './Prize';

const PrizeList = () => {
    const dispatch = useDispatch();
    const { prizeItems, prizeEditor } = useSelector((state) => state?.prize);
    const { hasReadOnly } = useSelector((state) => state?.auth?.user);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [showExpired, setShowExpired] = useState(false);

    const handleShowExpiredChange = (event) => {
        setShowExpired(event.target.checked);
        setPage(0);
    };
    const filteredRows = useMemo(() => {
        return showExpired
            ? prizeItems
            : prizeItems.filter((row) => row.status !== 'EXPIRED');
    }, [prizeItems, showExpired]);

    const paginatedRows = useMemo(() => {
        const start = page * rowsPerPage;
        return filteredRows.slice(start, start + rowsPerPage);
    }, [filteredRows, page, rowsPerPage]);

    useEffect(() => {
        dispatch(getPrizeList());
    }, [prizeEditor, dispatch]);
    const handleEdit = (id) => {
        dispatch(renderPrizeEditor(id));
    };
    const handleExpire = (id) => {
        const prize = prizeItems.find((item) => item.loyaltyPrizeItemId === id);
        const {
            prizeType,
            merchantId,
            merchantName,
            denominationId,
            denominationValue,
            denominationName,
            denominationQuantity,
        } = prize;
        const prizeExpirebody = createPrizeItemBody(
            prizeType,
            merchantId,
            merchantName,
            denominationId,
            denominationValue,
            denominationName,
            denominationQuantity,
            'EXPIRED'
        );
        dispatch(updatePrize(id, prizeExpirebody));
    };
    return (
        <>
            {prizeEditor.open ? (
                <Prize />
            ) : (
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>PrizeType</TableCell>
                                <TableCell>Prize Id</TableCell>
                                <TableCell>Merchant</TableCell>
                                <TableCell>Denomination</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell
                                    colSpan={2}
                                    sx={{ textAlign: 'center' }}
                                >
                                    Actions
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedRows.map((prize, id) => (
                                <TableRow key={id}>
                                    <TableCell>{prize.prizeType}</TableCell>
                                    <TableCell>
                                        {prize.loyaltyPrizeItemId}
                                    </TableCell>
                                    <TableCell>{prize.merchantName}</TableCell>
                                    <TableCell>
                                        {prize.denominationValue}
                                    </TableCell>
                                    <TableCell>
                                        {prize.denominationQuantity}
                                    </TableCell>
                                    <TableCell>{prize.status}</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>
                                        <Button
                                            variant="contained"
                                            onClick={() =>
                                                handleEdit(
                                                    prize.loyaltyPrizeItemId
                                                )
                                            }
                                        >
                                            {!hasReadOnly &&
                                            prize.status === 'DRAFT'
                                                ? 'Edit'
                                                : 'View'}
                                        </Button>
                                    </TableCell>
                                    {!hasReadOnly && (
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Button
                                                variant="outlined"
                                                onClick={() =>
                                                    handleExpire(
                                                        prize.loyaltyPrizeItemId
                                                    )
                                                }
                                                disabled={
                                                    prize.status === 'EXPIRED'
                                                }
                                            >
                                                Expire
                                            </Button>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Stack direction="row" spacing="2">
                            {!hasReadOnly && (
                                <Button
                                    variant="contained"
                                    sx={{ margin: '1rem 0' }}
                                    onClick={() =>
                                        dispatch(openPrizeEditor(undefined))
                                    }
                                >
                                    Add New Prize
                                </Button>
                            )}
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showExpired}
                                        onChange={handleShowExpiredChange}
                                    />
                                }
                                label="Show Expired"
                            />
                        </Stack>
                        <TablePagination
                            count={filteredRows.length}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onPageChange={(event, newPage) => setPage(newPage)}
                            onRowsPerPageChange={(event) => {
                                setRowsPerPage(
                                    parseInt(event.target.value, 10)
                                );
                                setPage(0);
                            }}
                            rowsPerPageOptions={[5, 10, 25]}
                            sx={{
                                borderBottom: 'none',
                            }}
                        />
                    </Box>
                </TableContainer>
            )}
        </>
    );
};

export default PrizeList;
